import type { TOC } from '@ember/component/template-only';
import { array, concat } from '@ember/helper';
import type { EmberChangeset } from 'ember-changeset';
import t from 'ember-intl/helpers/t';
import type { WrFormComponentSignature } from 'ember-wiser/components/form';

interface Signature {
  Args: {
    onClick: () => void;
    form: WrFormComponentSignature<
      EmberChangeset,
      void
    >['Blocks']['default'][0];
  };
}

export default <template>
  <@form.RadioRow
    @name='fistulasFlow'
    @label={{t 'mici-form.fistulasFlow.long' htmlSafe=true}}
    @onClick={{@onClick}}
    as |Radio|
  >
    {{#each (array '0' '1' '2' '3' '4') as |value|}}
      <Radio
        @value={{value}}
        @label={{t (concat 'mici-form.fistulasFlow.answers.' value)}}
      />
    {{/each}}
  </@form.RadioRow>
</template> satisfies TOC<Signature>;
